import { useRecoilValue } from "recoil";
import { weatherTimeWithID, WX_ID_SATELLITE } from "../../../store/WeatherContentsState";

function LegendSatCld() {
  const time = useRecoilValue(weatherTimeWithID(WX_ID_SATELLITE));

  return (
    <div>
      <div className="legend-contents-time cross-legend-contents-time">
        {time.baseTime}
      </div>
    </div>
  );
}

export default LegendSatCld;
